var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"screenshot",staticClass:"screenshot"},[_c('div',{staticClass:"image",style:({
			width: _vm.imageWidth,
			height: _vm.imageHeight,
		})},[_c('transition',{attrs:{"name":"component-fade-screenshots","mode":"out-in"}},[(!_vm.selectedScreenshot)?_c('img',{attrs:{"src":require("../../assets/images/screenshot-fallback.svg")}}):(!_vm.campaign.is_mobile)?_c('img',{attrs:{"src":_vm.getScreenshotUrl(_vm.screenshotUrl)}}):(_vm.campaign.is_mobile)?_c('div',{staticClass:"mobile-preview"},[_c('img',{class:_vm.campaign.type,attrs:{"src":_vm.screenshotUrl}})]):_vm._e()])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }